export enum CvStatus {
    HIDDEN = 'HIDDEN',
    INACTIVE = 'INACTIVE',
    ACTIVE = 'ACTIVE',
}
